import { useTranslation } from 'react-i18next';
import { Flex, Form, Spin } from 'antd';
import { SwitchEmail } from './ContactInfoForm.styles';
import { Card } from 'lib/components/Card/Card';
import { Input } from 'lib/components/Input/Input';
import { supportedLanguages } from 'app/cross-cutting-concerns/translations/Translations';
import { Select } from 'lib/components/Select/Select';
import { NotificationSubscriptionsActionTypes } from 'app/modules/notification/interfaces/Notification.types';

const languageOptions = Object.entries(supportedLanguages).map(([key, values]) => ({
  value: key,
  content: values.name,
}));

interface ContactInfoFormProps {
  isFormLoading: boolean;
  countryCode?: string;

  typeDrawer?: NotificationSubscriptionsActionTypes;
}

export const ContactInfoForm = ({ isFormLoading, typeDrawer }: ContactInfoFormProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card
      className="operator-details-drawer__card operator-details-drawer__information"
      title={t('notificationList.insertPanel.contactInfo.title')}
    >
      <Spin spinning={isFormLoading}>
        <Form.Item
          name="name"
          label={t('notificationList.insertPanel.contactInfo.name')}
          className="operator-details-drawer__input-group"
          required
          rules={[{ required: true, message: t('userList.operatorForm.form.errors.nameRequired') }]}
        >
          <Input
            className="operator-details-drawer__input"
            disabled={typeDrawer === NotificationSubscriptionsActionTypes.EDIT_NOTIFICATION_SUBSCRIPTION}
          />
        </Form.Item>

        <Form.Item
          name="language"
          label={t('notificationList.insertPanel.contactInfo.language')}
          className="operator-details-drawer__input-group operator-details-drawer__select"
          required
          rules={[{ required: true, message: t('userList.operatorForm.form.errors.languageRequired') }]}
        >
          <Select
            dropdownVisibleState
            className="operator-details-drawer__select"
            placeholder={t('userList.operatorForm.form.placeholderLanguage')}
            options={languageOptions.map(({ value, content }) => ({
              label: t(content),
              value,
            }))}
          />
        </Form.Item>

        <Form.Item
          name="email"
          label={t('notificationList.insertPanel.contactInfo.email')}
          className="operator-details-drawer__input-group"
          required
          rules={[
            { required: true, message: t('userList.operatorForm.form.errors.emailRequired') },
            {
              type: 'email',
              message: t('userList.operatorForm.form.errors.emailInvalid'),
            },
          ]}
        >
          <Input className="operator-details-drawer__input" />
        </Form.Item>

        <Flex align="center" gap={8}>
          <Form.Item
            name="emailSubscription"
            className="operator-form__checkbox"
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <SwitchEmail
              checkedChildren={t('common.yes')}
              unCheckedChildren={t('common.no')}
              defaultChecked={true}
              defaultValue={true}
            />
          </Form.Item>
          <span>{t('notificationList.insertPanel.notificationSelectEmail.question')}</span>
        </Flex>
      </Spin>
    </Card>
  );
};
